import { IPublicClientApplication } from '@azure/msal-browser';
import { GroupLead, GroupRequest } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  assignGroupLeads,
  createGroup,
  deleteGroup,
  deleteGroupLeads,
  getGroupLeads,
  getGroups,
  updateGroup,
} from './index';

export const createGroupsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createGroup: (instance: IPublicClientApplication, groupRequest: GroupRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createGroup(fetchContext, groupRequest, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createGroup', isInFlight);
    },
  ),
  updateGroup: (instance: IPublicClientApplication, groupId: number, groupRequest: GroupRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateGroup(fetchContext, groupId, groupRequest, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateGroup', isInFlight);
    },
  ),
  deleteGroup: (instance: IPublicClientApplication, groupId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteGroup(fetchContext, groupId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteGroup', isInFlight);
    },
  ),
  getGroups: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getGroups(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getGroups', isInFlight);
    },
  ),
  getGroupLeads: (instance: IPublicClientApplication, groupId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getGroupLeads(fetchContext, groupId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getGroupLeads', isInFlight);
    },
  ),
  assignGroupLeads: (instance: IPublicClientApplication, groupId: number, groupLead: GroupLead) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => assignGroupLeads(fetchContext, groupId, groupLead, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('assignGroupLeads', isInFlight);
    },
  ),
  deleteGroupLeads: (instance: IPublicClientApplication, groupLeadId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteGroupLeads(fetchContext, groupLeadId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteGroupLeads', isInFlight);
    },
  ),
});
